<template>
  <div class="topHeader">
    <img :src="imgPath + 'kv_second_half.png'" class="topHeader__kv" alt="超運2021年下半期">
    <div class="topHeader__lead">
      <p class="topHeader__text">お待たせしました！<br>
2021年下半期の運勢をお届けします。<br>
読み応えバツグン、満足度十分。<br>
実力派の監修陣が、様々なテーマで<br>
あなたの2021年下半期を占います。<br>
これからの1年、<br>
どんなことが待っているでしょう？<br>
さっそく占ってみてね！</p>
    </div>
    <!-- <img :src="imgPath + 'mizuhiki.png'" class="topHeader__mizuhiki" alt=""> -->
  </div>
</template>

<script>
export default {
  name: "topHeader",
  props: {
    imgPath: {
      type: String,
      default: '',
    }
  }
}
</script>

<style scoped lang="scss">
.topHeader {
  &__kv {
    max-width: 100%;
    vertical-align: middle;
  }
  &__lead {
    // padding: 16px 20px calc(10.1% + 24px);
    // margin: 0 auto -10.1%;
    padding: 16px 20px;
    margin: 0 auto;
    background: #FF3C28;
  }
  &__text {
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
    font-weight: bold;
    font-size: unquote('min(4vw, 18px)');
    line-height: 1.667;
    color: #FFFFFF;
    letter-spacing: -0.0667em;
  }
  &__mizuhiki {
    max-width: 100%;
    vertical-align: middle;
    position: relative;
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/topHeader.vue